import { normaliseReferralCode } from "./referralCodes";

const STORAGE_KEY = "lottery.referralCode";
const COOKIE_NAME = "lottery_referral_code";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90; // 90 days

function clearCookie(): void {
  if (typeof document === "undefined") {
    return;
  }
  try {
    document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax`;
  } catch (error) {
    console.warn("[referral] failed to clear referral cookie", error);
  }
}

function writeCookie(value: string): void {
  try {
    if (typeof document === "undefined") {
      return;
    }
    const encoded = encodeURIComponent(value);
    const expires = `max-age=${COOKIE_MAX_AGE_SECONDS}`;
    document.cookie = `${COOKIE_NAME}=${encoded}; ${expires}; path=/; SameSite=Lax`;
  } catch (error) {
    console.warn("[referral] failed to persist referral cookie", error);
  }
}

function readCookie(): string | null {
  if (typeof document === "undefined") {
    return null;
  }
  const cookies = document.cookie ? document.cookie.split(/;\s*/) : [];
  for (const cookie of cookies) {
    if (!cookie) continue;
    const [name, ...rest] = cookie.split("=");
    if (name === COOKIE_NAME) {
      const value = rest.join("=");
      if (value) {
        try {
          return decodeURIComponent(value);
        } catch {
          return value;
        }
      }
    }
  }
  return null;
}

function writeLocalStorage(value: string): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    console.warn("[referral] failed to persist referral in localStorage", error);
  }
}

function readLocalStorage(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    console.warn("[referral] failed to read referral from localStorage", error);
    return null;
  }
}

function clearLocalStorage(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn("[referral] failed to clear referral from localStorage", error);
  }
}

export function rememberReferralCode(input: string | null | undefined): string | null {
  const normalized = normaliseReferralCode(input ?? null);
  if (!normalized) {
    return null;
  }
  writeLocalStorage(normalized);
  writeCookie(normalized);
  return normalized;
}

export function getStoredReferralCode(): string | null {
  const fromLocal = readLocalStorage();
  if (fromLocal) {
    return normaliseReferralCode(fromLocal);
  }
  const fromCookie = readCookie();
  if (fromCookie) {
    const normalized = normaliseReferralCode(fromCookie);
    if (normalized) {
      writeLocalStorage(normalized);
      return normalized;
    }
  }
  return null;
}

export function clearStoredReferralCode(): void {
  clearLocalStorage();
  clearCookie();
}
